export type RuntimeType = 'EC2' | 'ECS';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isRuntimeType = (data: any): data is RuntimeType => data === 'EC2' || data === 'ECS';
